import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProducts } from 'app/entities/product/product.reducer';
import { getEntities as getDeals } from 'app/entities/deal/deal.reducer';
import { createEntity, getEntity, reset, updateEntity } from './deal-product.reducer';

export const DealProductUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const products = useAppSelector(state => state.product.entities);
  const deals = useAppSelector(state => state.deal.entities);
  const dealProductEntity = useAppSelector(state => state.dealProduct.entity);
  const loading = useAppSelector(state => state.dealProduct.loading);
  const updating = useAppSelector(state => state.dealProduct.updating);
  const updateSuccess = useAppSelector(state => state.dealProduct.updateSuccess);

  const handleClose = () => {
    navigate(`/deal-product${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProducts({}));
    dispatch(getDeals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }

    const entity = {
      ...dealProductEntity,
      ...values,
      product: products.find(it => it.id.toString() === values.product?.toString()),
      deal: deals.find(it => it.id.toString() === values.deal?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...dealProductEntity,
          product: dealProductEntity?.product?.id,
          deal: dealProductEntity?.deal?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tycheApp.dealProduct.home.createOrEditLabel" data-cy="DealProductCreateUpdateHeading">
            <Translate contentKey="tycheApp.dealProduct.home.createOrEditLabel">Create or edit a DealProduct</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="deal-product-id"
                  label={translate('tycheApp.dealProduct.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tycheApp.dealProduct.quantity')}
                id="deal-product-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
              />
              <ValidatedField
                label={translate('tycheApp.dealProduct.keyword')}
                id="deal-product-keyword"
                name="keyword"
                data-cy="keyword"
                type="text"
              />
              <ValidatedField
                id="deal-product-product"
                name="product"
                data-cy="product"
                label={translate('tycheApp.dealProduct.product')}
                type="select"
              >
                <option value="" key="0" />
                {products
                  ? products.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="deal-product-deal"
                name="deal"
                data-cy="deal"
                label={translate('tycheApp.dealProduct.deal')}
                type="select"
              >
                <option value="" key="0" />
                {deals
                  ? deals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/deal-product" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DealProductUpdate;
